<template>
  <artmisads-modal  v-model:open="visible" :width="720" :maskClosable="false" :closable="false" :closeIcon="false"
    :footer="null" :header="false" :bodyStyle="{ padding: '0' }" class="link-bonus-modal">
    <div class="modal-content-container">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          <p>ACC Bonus Program Released!</p>
        </div>
        <svg-icon class="icon-app" name="close-cu" @click="handleClose"/>
      </div>
      <div class="modal-body">
        <p class="title">Dear Publisher,</p>
        <p class="description description-bold">
          We are excited to announce that the ArtemisAds ACC Bonus Program is now live!
        </p>
        <p class="description">
          Please upload and save your Amazon Associate StoreID so that more brands can invite you to join their ACC Bonus Program. You can also explore and accept ACC Campaigns from more premium brands on ArtemisAds.
        </p>
      </div>
      <div class="footer-btns">
        <artmisads-button :loading="loading" type="primary" class="get-start-btn" @click="handleGetStart">View ACC Bonus Programs</artmisads-button>
      </div>
    </div> 
      <div class="modal-footer">
        <a-checkbox v-model:checked="checked">Don't show this again</a-checkbox>
      </div>
      <!-- <div class="learn-more">
        <a href="javascript:;" @click="handleLearnMore">Learn more about our bonus program</a>
      </div> -->
    </div>
  </artmisads-modal>
</template>

<script setup>


import { ref } from 'vue'
import { useRouter } from 'vue-router'
import {
 publisherDashboardApi,
} from "~/server/index"
// import { useUserInfoStore } from '../../../../storeData/index';
import SvgIcon from '~/components/SvgIcon.vue'
const router = useRouter()

const checked = ref(true)

const visible = ref(false)
const emit = defineEmits(['close'])
const loading = ref(false)
const handleClose = async () => {
  visible.value=false
}

const handleGetStart = async () => {
  loading.value = true
  if(checked.value){
    publisherDashboardApi.dismissPopActive({
      key: 'acc_bonus_program_released'
    }).then(res => {
      if(res.success){
        router.push('/publisher/creatorConnections/bonusPrograms')
      }
    })
  }else{
    router.push('/publisher/creatorConnections/bonusPrograms')
  }
  
  loading.value = false
  emit('close')
}

const showModal = () => {
  visible.value = true
}

defineExpose({
  showModal
})
</script>

<style scoped lang="less">

.link-bonus-modal {
  :deep(.artmisads-modal-content) {
    border-radius: 8px;
    overflow: hidden;
    padding: 24px;
    background-image: url('../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .modal-content-container{
    // background-color: #FBFBFE;
  }
  .modal-footer {
    text-align: center;
    margin-top: -40px;
    padding: 0 24px 18px;
    flex-shrink: 0;
  }

  .modal-content-container {
    display: flex;
    flex-direction: column;
  }

  .modal-content {
    min-height: 420px;
    text-align: left;
    background-image: url('../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;

    .modal-header {
      position: relative;
      flex-shrink: 0;
      .icon-app{
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 24px;
        cursor: pointer;
        z-index: 1;
      }
      .modal-header-title {
        color: #0f0629;
        font-family: "Sora", sans-serif;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding: 24px 72px 20px 40px;
        letter-spacing: 0.69px;
        line-height: 1.25;

        p {
          margin: 0;
          word-break: break-word;
        }
      }
    }

    .modal-body {
      border-radius: var(--Radius-Radius-10, 10px);
      padding: 20px 30px;
      margin: 0 40px;
      border: 1px solid #FFF;
      background: #FFF;
      box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;

      .title {
        color: #0f0629;
        font-family: "Sora", "PingFang SC", sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        margin: 0 0 12px;
        line-height: 1.4;
      }

      .description {
        color: #0f0629;
        font-family: "PingFang SC", "Sora", sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin: 0 0 16px;

        &.description-bold {
          font-weight: 600;
          margin-bottom: 12px;
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .footer-btns {
      text-align: center;
      margin: 24px 40px 0;
      padding: 0;

      :deep(.artmisads-btn) {
        min-width: 200px;
        max-width: calc(100% - 80px);
        height: auto;
        min-height: 40px;
        padding: 8px 24px;
        white-space: normal;
        line-height: 1.4;
      }
    }

    .learn-more {
      text-align: center;

      a {
        font-size: 14px;
        color: var(--primary-color);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>